"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Hotkeys;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CommonContentModule = _interopRequireDefault(require("../CommonContent.module.scss"));

var _HotkeysModule = _interopRequireDefault(require("./Hotkeys.module.scss"));

var _entries = _interopRequireDefault(require("./entries"));

var _Button = _interopRequireDefault(require("../../../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../../../inputElements/Button/EButtonType"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Hotkeys(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_CommonContentModule.default.content, _HotkeysModule.default.content, className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _HotkeysModule.default.entries
  }, /*#__PURE__*/_react.default.createElement("table", null, /*#__PURE__*/_react.default.createElement("tbody", null, _entries.default.map(function (entry) {
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: entry.label
    }, /*#__PURE__*/_react.default.createElement("td", null, entry.label), /*#__PURE__*/_react.default.createElement("td", null, entry.value));
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: _CommonContentModule.default.buttonFooter
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.OPTION
  }, "Reset"), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.OPTION
  }, "Ok")));
}